<template>
    <div id="reseller-wrap" v-bind:class="{loading:loading}">

        <div id="reseller-search">

            <div class="row justify-content-center">

                <div class="form-group col-24 col-md-10">
                    <div class="inner-addon right-addon">
                        <span class="inner-addon-icon juh-icon juh-icon-search"></span>
                        <input type="search" class="form-control" v-model="search" placeholder="Gib deine Stadt ein">
                    </div>
                </div>

                <div class="form-group col-auto">

                    <button type="button" class="btn btn-primary" @click="getCurrentPosition" :class="{disabled: locating == true}">
                        <i v-if="locating == false" class="juh-icon juh-icon-navigation"></i>
                        <span v-else class="spinner-border spinner-border-sm mr-2"></span>
                        Aktuelle Position verwenden
                    </button>

                </div>

            </div>

        </div>

        <div id="reseller-overview">

            <div class="row">
                <div class="col-md-10">

                    <!-- <pre>{{ bounds }}</pre> -->

                    <div id="reseller-list-wrap" v-bar>

                        <div id="reseller-list">

                            <div class="reseller-item" v-for="reseller in filteredResellers" @click="activateMarker(reseller.id)" v-bind:key="reseller.id">

                                <figure class="reseller-image">
                                    <img :src="reseller.image || fallback_image" :alt="reseller.title" :title="reseller.title">
                                    <figcaption>{{ reseller.title }}</figcaption>
                                </figure>

                                <div class="reseller-details">
                                    <h3 class="reseller-title">{{ reseller.title }}</h3>
                                    <p class="reseller-address">
                                        {{ reseller.address }}<br>
                                        {{ reseller.zipcode }} {{ reseller.city }}
                                    </p>
                                </div>

                            </div>

                            <a v-if="filteredResellers.length == 0"
                                :href="'/kontakt/empfehlung-geben/?your-message=' + encodeURIComponent('Hey, in ' + search + ' sollte es unbedingt Jackle & Heidi geben!')"
                                class="d-block p-3 border border-white rounded text-center"
                            >
                                Noch nicht. Du kannst das ändern.
                            </a>

                        </div>

                    </div>

                </div>

                <div class="col-md-14">
                    <div id="reseller-map"></div>
                </div>

            </div>

            <div id="reseller-loader"></div>

        </div>

    </div>
</template>

<script>
// JS
import L from 'leaflet';
import {GestureHandling} from "leaflet-gesture-handling";

// CSS
import '../../../node_modules/leaflet/dist/leaflet.css';
import '../../../node_modules/leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

// Fix from here: https://github.com/KoRiGaN/Vue2Leaflet/issues/28
// delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = wp_theme_url + '/assets/images/';
L.Icon.Default.mergeOptions({
    iconUrl:            'pin.svg',
    shadowUrl:          'pin-shadow.svg',
    iconRetinaUrl:      'pin.svg',
    iconRetinaShadow:   'pin-shadow.svg',
    iconSize:           [20, 24],
    shadowSize:         [28, 25],
    iconAnchor:         [10, 24],
    shadowAnchor:       [10, 21],
    popupAnchor:        [0, -14],
});

export default {
    props: {
        filterHumanAware: {
            type: Boolean,
            default: false
        },
        filterDogAware: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            fallback_image: fallback_image,
            api_url: 'https://app.jackle-heidi.com/customer-sales-api/v1/resellers.json',
            loading: true,
            locating: false,
            map: null,
            accessToken: 'pk.eyJ1IjoiMTNncmFkIiwiYSI6ImNqdnh5and3dDA5am80OHJybnRkOWFjc3AifQ.HAZyMV7AlNn6AIQ2o2CxcA',
            mapBoxStyle: '13grad/cjt5s8x3502di1fmky3bv5tur',
            resellers: [],
            bounds: [],
            search: '',
            zoom: 13,
        }
    },

    mounted() {
        this.initMap();
        this.getMarkers();
    },

    methods: {

        initMap() {

            var _this = this;

            _this.map = L.map('reseller-map', {
                zoomControl: false,
                gestureHandling: true
            });

            _this.map.on('locationfound', _this.onLocationFound);
            _this.map.on('locationerror', _this.onLocationError);

            L.control.zoom({position:'topright'}).addTo(_this.map);

            L.tileLayer('https://api.mapbox.com/styles/v1/{mapBoxStyle}/tiles/256/{z}/{x}/{y}{r}?access_token={accessToken}', {
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                accessToken: _this.accessToken,
                mapBoxStyle: _this.mapBoxStyle,
            }).addTo(_this.map);

        },

        getMarkers() {

            var _this = this;

            let queryParams = new URLSearchParams({
                'order[zipcode]': 'asc',
            });

            if (_this.filterHumanAware) {
                queryParams.append('humanAware', true);
            }

            if (_this.filterDogAware) {
                queryParams.append('dogAware', true);
            }

            let queryString = _this.api_url + '?' + queryParams.toString();

            // Get resellers from API
            $.getJSON(queryString, function(resellers){

                // Loop through resellers
                for (var i = 0; i < resellers.length; i++) {

                    if (resellers[i].active === false) continue;

                    if (resellers[i].latitude === null || resellers[i].longitude === null) continue;

                    var image = null;
                    if (resellers[i].image) {
                        var image = resellers[i].image.url;
                    }

                    var reseller = {
                        id: i,
                        title: resellers[i].name,
                        address: resellers[i].street,
                        zipcode: resellers[i].zipcode,
                        city: resellers[i].city,
                        coords: [resellers[i].latitude, resellers[i].longitude],
                        image: image
                    };

                    var coords   = reseller.coords,
                        marker   = null;

                    let content = '<p><strong>' + reseller.title + '</strong><br>' + reseller.address + '<br>' + reseller.zipcode + ' ' + reseller.city + '</p>';

                    marker = L.marker(coords);
                    marker.bindPopup(content);
                    marker.addTo(_this.map);

                    _this.resellers.push(Object.assign(reseller, {marker: marker}));
                    _this.bounds.push(coords);

                }

                if( _this.bounds.length > 0 ) {
                    _this.map.fitBounds(new L.LatLngBounds(_this.bounds), {
                        maxZoom: _this.zoom
                    });
                }

                _this.loading = false;

            });

        },

        activateMarker( id ) {

            var reseller = this.resellers.find(reseller => reseller.id === id),
                marker   = reseller.marker,
                coords   = marker.getLatLng();

            this.map.setView(coords, this.zoom);
            marker.openPopup();

        },

        getCurrentPosition() {

            this.locating = true;

            this.map.locate({
                setView: true,
                maxZoom: 16,
            });
        },

        onLocationFound(e) {

            this.locating = false;

            $('html,body').animate({
                scrollTop: $('#reseller-wrap').offset().top
            });

            // var _this  = this,
            //     map    = this.map,
            //     coords = e.latlng,
            //     radius = e.accuracy;

            // let circle = L.circle(e.latlng, {
            //     radius: radius,
            //     color: '#3C978E',
            //     opacity: 0.4,
            //     weight: 1,
            //     fillOpacity: 0.2
            // });

            // circle.bindPopup('Sie befinden sich in einem Umkreis von ' + radius + ' Metern um diesen Punkt');
            // circle.addTo(map);
            // circle.openPopup();

        },

        onLocationError(e) {
            alert( e.message );
        },

    },

    computed: {
        filteredResellers() {

            var _this = this;

            var resellers = _this.resellers.filter(function(reseller){

                var titleSearch     = reseller.title.toLowerCase().includes(_this.search.toLowerCase()),
                    citySearch      = reseller.city.toLowerCase().includes(_this.search.toLowerCase()),
                    addressSearch   = reseller.address.toLowerCase().includes(_this.search.toLowerCase()),
                    zipCodeSearch   = reseller.zipcode.toLowerCase().includes(_this.search.toLowerCase());

                return titleSearch || citySearch || addressSearch || zipCodeSearch;

            });

            _this.bounds = [];

            for (var i = 0; i < resellers.length; i++) {
                _this.bounds.push(resellers[i].coords);
            }

            if( _this.map && resellers.length > 0 ) {

                _this.map.fitBounds(new L.LatLngBounds(_this.bounds), {
                    maxZoom: 15
                });
            }

            return resellers;
        }
    }
}
</script>
